<template class="relative w-full h-auto">
	<div
		v-if="showCart"
		class="fixed inset-0 h-screen w-screen z-50"
	>
		<!-- Left Black Side -->
		<div
			class="hidden sm:block sm:w-1/4 md:w-1/2 lg:w-2/3 absolute top-0 left-0 h-full bg-black/50"
		></div>

		<!-- Right Blank Side -->
		<div class="absolute top-0 right-0 h-full w-full sm:w-3/4 md:w-1/2 lg:w-1/3">
			<CartComponent
				:toggle="toggleCart"
				class="h-full"
			/>
		</div>
	</div>

	<!-- <div>
		<CartComponent
			v-if="showCart"
			:toggle="toggleCart"
			class="fixed"
			style="z-index: 99"
		/>
	</div> -->

	<div
		v-if="showChat"
		class="fixed z-40 bottom-2 right-2"
	>
		<a
			target="_blank"
			href="https://api.whatsapp.com/send?phone=5215524715466&text=¡Hola!%20Tengo%20dudas%2C%20¿me%20puedes%20ayudar%3F"
		>
			<div
				class="bg-accent-blue text-vc-small text-white w-full px-4 py-2 text-center cursor-pointer rounded-full hover:bg-blue-dark font-medium"
			>
				Chatea
			</div>
		</a>
	</div>
	<div class="w-full min-h-screen flex flex-col">
		<div class="w-full h-full bg-background flex flex-col">
			<div
				class="sticky top-0 flex items-center flex-0 bg-background border-b border-accent-green p-2 px-2 z-30"
			>
				<router-link
					:to="'/'"
					class="grow-0 shrink-0 h-8 w-8"
				>
					<img
						class="w-full h-full"
						src="./assets/logo.png"
					/>
				</router-link>

				<div class="flex flex-row space-x-4 items-center select-none overflow-x-scroll px-4 grow">
					<div
						:class="page == 'home' ? 'font-medium' : ''"
						style="font-size: 16px"
					>
						<router-link :to="'/'"> Inicio </router-link>
					</div>
					<div
						:class="page == 'club' ? 'font-medium' : ''"
						style="font-size: 16px"
					>
						<router-link :to="'/club-chidos'"> Club </router-link>
					</div>
					<div
						:class="page == 'shop' ? 'font-medium' : ''"
						style="font-size: 16px"
					>
						<router-link :to="'/shop'"> Shop </router-link>
					</div>
					<div
						:class="page == 'tiendas' ? 'font-medium' : ''"
						style="font-size: 16px"
					>
						<router-link :to="'/tiendas'"> Tiendas </router-link>
					</div>
					<div
						:class="page == 'experiencias' ? 'font-medium' : ''"
						style="font-size: 16px"
					>
						<router-link :to="'/experiencias'"> Experiencias </router-link>
					</div>
				</div>

				<div
					v-if="showCartIcon"
					class="text-vc-tiny bg-accent-red hover:bg-accent-red-dark rounded-full grow-0 shrink-0 flex justify-center items-center text-white w-8 h-8 cursor-pointer"
					@click="toggleCart()"
				>
					<div class="leading-none pt-0.5 font-medium">
						{{ getCartItems() }}
					</div>
				</div>
			</div>
			<RouterView class="flex-1" />
		</div>
	</div>
</template>

<script>
import { onMounted, computed, ref, watch } from 'vue'
import { useRoute } from 'vue-router'
import { RouterView } from 'vue-router'
import { useCartStore } from './stores/cart'
import CartComponent from '@/components/CartComponent.vue'
import axios from 'axios'
import { trackPageView } from '@/services/facebookAnalytics'

export default {
	components: {
		RouterView,
		CartComponent
	},
	setup() {
		const store = useCartStore()
		let route = useRoute()

		let showCart = ref(false)
		let showChat = ref(true)

		const page = ref('home')

		function getCartItems() {
			return store.getCartItems()
		}

		// Add watch for showCart to handle body scroll
		watch(showCart, (newValue) => {
			if (newValue) {
				document.body.style.overflow = 'hidden'
			} else {
				document.body.style.overflow = ''
			}
		})

		function updatePageFromRoute(routeName) {
			if (routeName == 'Shop' || routeName == 'Colección' || routeName == 'Producto') {
				page.value = 'shop'
			} else if (routeName == 'Experiencias') {
				page.value = 'experiencias'
			} else if (routeName == 'Tiendas') {
				page.value = 'tiendas'
			} else if (routeName == 'Club Chidos') {
				page.value = 'club'
			} else if (routeName == 'Home') {
				page.value = 'home'
			} else if (routeName == 'Hecho con Uvas Chidas') {
				page.value = 'hcuc'
			} else {
				page.value = ''
			}
		}

		async function checkCartCompletion() {
			console.log('Starting cart completion check...')
			console.log('Current Shopify Cart ID:', store.shopifyCartId)

			if (!store.shopifyCartId) {
				console.log('No Shopify Cart ID found, skipping check')
				return
			}

			try {
				console.log('Fetching cart status from API...')
				const { data } = await axios.get(`/api/shopify/check-cart?cartId=${store.shopifyCartId}`)
				console.log('Cart status response:', data)

				if (data.completed) {
					console.log('Cart is completed, clearing local cart...')
					store.clearCart()
					console.log('Local cart cleared successfully')
				} else {
					console.log('Cart is still active')
				}
			} catch (error) {
				console.error('Error checking cart completion:', error)
				if (error.response) {
					console.error('Error response:', {
						status: error.response.status,
						data: error.response.data
					})
				}
			}
		}

		onMounted(async () => {
			await checkCartCompletion()
			await store.fetchMerch()
			updatePageFromRoute(route.name)
		})

		watch(
			() => route.name,
			(newRouteName) => {
				updatePageFromRoute(newRouteName)
				// Track page view on route change
				trackPageView(window.location.href)
			}
		)

		function toggleCart() {
			showCart.value = !showCart.value
		}

		const showCartIcon = computed(() => {
			if (route.name == 'Checkout') {
				return false
			}

			return true
		})

		return {
			page,
			getCartItems,
			showCartIcon,
			showCart,
			showChat,
			toggleCart,
			store
		}
	}
}
</script>
